<template>
  <div class="address" :class="{'form_item' : !displayFormAddress}" v-if="scriptLoaded">
    <Label v-if="!displayFormAddress" :required="required" :label="label" for_id="map"/>
    <div class="recap_address" v-if="displayRecap">
      <div>
        <span class="recap_value_address-address">{{ val.address }}</span>
        <span class="recap_value_address-comma" v-if="val.complement">, </span>
        <span class="recap_value_address-complement" v-if="val.complement">{{ value.complement }}</span>
        <span class="recap_value_address-comma" v-if="val.postcode">, </span>
        <span class="recap_value_address-postcode">{{ val.postcode }}&nbsp;</span>
        <span class="recap_value_address-city">{{ val.city }}</span>
      </div>
      <div>
        <a href="#" @click.prevent="displayRecap = false">{{$t('changez_votre_adresse', locale)}}</a>
      </div>
    </div>
    <GoogleAutocomplete v-if="!displayFormAddress && scriptLoaded && !displayRecap"
      :id="'id_'+inputName"
      :required="required"
      :placeholder="placeholder"
      :key="save_to"
      :name="inputName"
      :country="countries"
      v-on:placechanged="getAddressData"
      @blur.native="onBlur()"
      ref="autocompleteGoogleField"
    />
    <p v-if="info !== undefined && !displayFormAddress  && !displayRecap" class="info" v-html="info"></p>
    <span v-if="!displayFormAddress  && !displayRecap" class="error" v-show="errors.has(label)">{{ errors.first(label) }}</span>
    <div v-if="!displayFormAddress  && !displayRecap" class="cannotfind">
      <a @click="displayFormAddress = true; $emit('cannot-find')">{{$t('trouvepasadresse', this.locale)}}</a>
    </div>
    <Input v-if="displayFormAddress && !displayRecap"
      :label="$t('N_rue', locale)"
      type="text"
      name="rue"
      key="rue"
      required
      autocomplete="address-line1"
      v-model="val.address"
    />
    <Input v-if="displayFormAddress"
      :label="$t('compl_addresse', locale)"
      type="text"
      name="complement"
      key="rue-complement"
      :required="false"
      validationRules=""
      autocomplete="address-line2"
      v-model="val.complement"
    />
    <Input v-if="displayFormAddress"
      :label="$t('ville', locale)"
      type="text"
      name="ville"
      key="ville"
      required
      autocomplete="address-level2"
      v-model="val.city"
    />
    <Input v-if="displayFormAddress"
      :label="$t('code_postal', locale)"
      :type="(locale == 'fr')?'tel':'text'"
      name="postcode"
      key="postcode"
      :validationRules="(locale == 'fr')?{'numeric': true,'length':5}:{}"
      required
      autocomplete="postal-code"
      v-model="val.postcode"
    />
  </div>
</template>

<script>
import GoogleAutocomplete from './GoogleAutocomplete';
import Input from './Input';
import Recap from './Recap';
import { validatorComponent } from './validatorComponentMixin';
import { customBlurMixin } from './customBlurMixin';
import i18n from './i18n';

export default {
  name: 'Address',
  mixins: [validatorComponent, customBlurMixin, i18n.mixin],
  components: {
    Input,
    GoogleAutocomplete,
    Recap
  },
  props: {
    save_to: String,
    placeholder: String,
    label: String,
    validationLabel: String,
    googleMapsApiKey: String,
    countries: Array,
    locale: String,
    configuration: Object,
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      inputName: "d_" + Date.now() + "_d",
      scriptLoaded: false,
      adresseIncorrecte: false,
      displayFormAddress: false,
      displayRecap: false,
    };
  },
  mounted () {
    //console.log(this.val)
    if(!this.val) {
      this.val = {
        address: undefined,
        postcode: undefined,
        city: undefined,
        complement: undefined,
        latitude: undefined,
        longitude: undefined,
        administrative_area_level_1: undefined,
        administrative_area_level_2: undefined,
        country: undefined,
      }
    } else if(this.val.address){
      this.displayRecap = true;
    }
    if(!this.countries || this.countries.length == 0) {
      this.displayFormAddress = true;
      this.scriptLoaded = true;
      return;
    }
    if(this.configuration && this.configuration.forceForm) {
      this.displayFormAddress = true;
    }
    let interval = setInterval(()=>{
      if(this.$refs['autocompleteGoogleField'] && this.$refs['autocompleteGoogleField'].$el.className.indexOf('gm-err-autocomplete') > -1) {
        alert("Please check google maps autocomplete configuration")
        console.error("Google maps error detected");
        clearInterval(interval);
      }
    }, 1000);

    if(!(window.google && window.google.maps)) {
      window.mapsLoaded = ()=>{
        console.log("Google place js API loaded");
        this.scriptLoaded = true;
      }
      
      const mapsScript = document.createElement('script');
      mapsScript.setAttribute('src', `https://maps.googleapis.com/maps/api/js?key=${this.googleMapsApiKey}&libraries=places&callback=mapsLoaded`);
      document.head.appendChild(mapsScript);
    } else {
      this.scriptLoaded = true;
    }
  },
  methods: {
    getAddressData (data) {
      console.log(data);
      this.val.city = data.locality;
      if(data.street_number !== undefined) {
        this.val.address = `${data.street_number} ${data.route}`;
      } else {
        this.val.address = data.route;
      }
      this.val.postcode = data.postal_code;
      this.val.latitude = data.latitude;
      this.val.longitude = data.longitude;
      this.val.administrative_area_level_1 = data.administrative_area_level_1;
      this.val.administrative_area_level_2 = data.administrative_area_level_2;
      this.val.country = data.country;
      this.adresseIncorrecte = false;

      if(this.configuration && this.configuration.displayFieldsAfterSelection) {
        this.displayFormAddress = true;
      }
    }
  }
};
</script>

<style scoped>
.cannotfind {
  cursor: pointer;
}
</style>
